import { Link } from "react-router-dom";
import { ROUTES } from "../../../constants";

type Props = {
  brandProfileImage: string;
  brandName: string;
  brandDescription: string;
  brandCoverImage: string;
  brandId: string;
};
function BrandDetailsCard({ brandProfileImage, brandName, brandDescription, brandCoverImage, brandId }: Props) {
  return (
    <Link
      className="discover-brand-card group relative h-72 w-full cursor-pointer 2xl:h-80"
      to={`${ROUTES.BRAND_PUBLIC_PROFILE}/${brandId}`}
    >
      <div
        className="h-60 w-full overflow-hidden rounded-xl border-2 border-gray-700 shadow-[0.2rem_0.8rem_0.5rem_rgba(10,10,10,0.8)] transition-all group-hover:shadow-[0.2rem_0.8rem_0.5rem_rgba(0,0,0,0.6)] 2xl:h-64"
        style={{ backgroundImage: `url("${brandCoverImage}")`, backgroundSize: "200%" }}
      >
        <img className="h-full w-full object-contain backdrop-blur-lg" src={brandCoverImage} alt={brandName} />
      </div>
      <div
        className="absolute left-1/2 top-44 flex
              w-11/12 -translate-x-1/2 transform  space-x-2 rounded-2xl
              border-2 border-white border-opacity-10 bg-primary
             p-2 shadow-[0.2rem_0.8rem_0.5rem_rgba(10,10,10,0.8)] transition-all hover:z-10 group-hover:shadow-[0.2rem_0.8rem_0.5rem_rgba(0,0,0,0.6)] 2xl:p-4"
      >
        <img
          className="h-20 w-20 shrink-0 rounded-ll border-2 border-white border-opacity-20 object-cover 2xl:h-24 2xl:w-24"
          src={brandProfileImage}
          alt={brandName}
        />
        <div className="truncate" title={brandName}>
          <p
            className="truncate font-satoshi text-sm font-bold
                leading-6 text-white md:text-lg
                2xl:text-[22px] 2xl:leading-9"
          >
            {brandName}
          </p>
          <p
            title={brandDescription}
            className="mt-1 line-clamp-3  w-full whitespace-normal break-words font-satoshi text-xxs
                font-medium leading-5 text-white text-opacity-80
                first-letter:uppercase md:text-xs 2xl:line-clamp-2 2xl:text-xs 2xl:leading-6"
            // hover:line-clamp-none
          >
            {brandDescription}
          </p>
        </div>
      </div>
    </Link>
  );
}
export default BrandDetailsCard;
